import { useEffect, useState } from 'react';
import { Input, Popconfirm, Radio, Table } from 'antd';
import {
  AlertIcon,
  BinIcon,
  CloseAiIcon,
  EditableIcon,
  UpdateIcon,
} from 'src/icons';
import { useDispatch } from 'react-redux';
import {
  addRecentSearchAction,
  getRecentSearchAction,
} from 'src/store/actions/appointment.action';
import { showToastSuccess } from 'src/utilities/toast';
import { showToastError } from 'src/utilities/errortoast';
import { ModalComponent } from '../baseComponents';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';

export const ManageSearchEncounterModal = ({
  isMangeViewOpen,
  handleCloseManageView,
  recentSearchList,
  setRenameTitleEncounter,
  resetFilters,
  selectedTitleEncounter,
}) => {
  const dispatch = useDispatch();

  const [showError, setShowError] = useState(false);

  const isMobile = window.innerWidth < 1260;

  useEffect(() => {
    if (isMangeViewOpen) {
      dispatch(getRecentSearchAction('encounters'));
    }
  }, [isMangeViewOpen, dispatch]);

  const [isEditing, setIsEditing] = useState(false);
  const [editedTitle, setEditedTitle] = useState('');
  const { user } = useAuth();

  const handleEditClick = (record) => {
    setIsEditing(record.id);
    setEditedTitle(record.title);
  };

  const handleTickClick = (record) => {
    analytics.track('Clicked Edit This View In Aura Custom Views', {
      title: record?.title,
      email: user?.email,
    });
    const updatedRecordIndex = recentSearchList.search_preference.findIndex(
      (item) => item.id === record.id
    );
    if (updatedRecordIndex !== -1) {
      const updatedSearchPreference = recentSearchList.search_preference.map(
        (item, index) => {
          if (index === updatedRecordIndex) {
            return { ...item, title: editedTitle };
          }
          return item;
        }
      );
      dispatch(addRecentSearchAction(updatedSearchPreference, 'encounters'));
      setIsEditing(false);
      if (selectedTitleEncounter === record?.title) {
        setRenameTitleEncounter(editedTitle);
      }
      showToastSuccess(`View renamed successfully.`);
    } else {
      console.error('Record not found');
    }
  };

  const handleDelete = (record) => {
    analytics.track('Clicked Delete This View In Aura Custom Views', {
      title: record?.title,
      email: user?.email,
    });

    const updatedSearchPreference = recentSearchList.search_preference.filter(
      (item) => item.id !== record.id
    );

    dispatch(addRecentSearchAction(updatedSearchPreference, 'encounters'))
      .then(() => {
        if (selectedTitleEncounter === record?.title) {
          resetFilters();
        }
        showToastSuccess(`View deleted successfully.`);
      })
      .catch(() => showToastError('Failed to delete the view.'));
  };

  const handleXClick = () => {
    setIsEditing(false);
  };

  const handleRenameEdit = (event) => {
    const value = event.target.value;
    setEditedTitle(value);
    if (value === '') {
      setShowError(true);
    } else {
      setShowError(false);
    }
  };

  const handleRadioChange = async (selectedRecord) => {
    const updatedSearches = (recentSearchList?.search_preference || []).map(
      (record) => {
        // If the record is the selected one, set its isDefaultView to true
        if (record.id === selectedRecord.id) {
          return { ...record, isDefaultView: true };
        }

        // Otherwise, set its isDefaultView to false
        return { ...record, isDefaultView: false };
      }
    );

    dispatch(addRecentSearchAction(updatedSearches, 'encounters'));

    showToastSuccess('Default preference updated');
  };

  const columnsDesktop = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      width: 250,
      render: (text, record) => (
        <div className="">
          {isEditing === record.id ? (
            <div className="">
              <div className="flex gap-2 items-center">
                <div className="flex items-center border border-[#e5e8eb] rounded-lg">
                  <Input
                    id="rename"
                    bordered={false}
                    value={editedTitle}
                    onChange={handleRenameEdit}
                    className="bg-white shadow-md"
                  />
                </div>
                <div
                  id="updateIcon"
                  className="bg-[#00d091] rounded-full flex items-center justify-center p-1"
                >
                  <UpdateIcon
                    onClick={() =>
                      editedTitle.trim() !== ''
                        ? handleTickClick(record)
                        : setShowError(true)
                    }
                  />
                </div>
                <div
                  id="closeIcon"
                  className="ml-2 bg-[#d63232] rounded-full flex items-center justify-center p-1"
                >
                  <CloseAiIcon
                    stroke="#ffffff"
                    fill="#ffffff"
                    onClick={handleXClick}
                  />
                </div>
              </div>
              {showError &&
                isEditing === record.id &&
                !editedTitle.length > 0 && (
                  <div className="text-red-500 text-xs mt-1">
                    Title cannot be empty.
                  </div>
                )}
            </div>
          ) : (
            <div className="flex items-center">
              <div>{text}</div>
              <div className="ml-5">
                <EditableIcon onClick={() => handleEditClick(record)} />
              </div>
            </div>
          )}
        </div>
      ),
    },
    {
      title: 'Filters',
      dataIndex: 'variables',
      key: 'variables',
    },
    {
      title: 'Default View',
      dataIndex: '',
      key: 'actions',
      render: (text, record) => {
        return (
          <div className="flex space-x-6 ml-8">
            <Radio
              checked={record?.isDefaultView}
              onChange={() => handleRadioChange(record)}
            />
          </div>
        );
      },
    },
    {
      title: <div className=""></div>,
      key: 'actions',
      render: (text, record) => (
        <div className="flex space-x-6 manage_popup">
          <Popconfirm
            okButtonProps={{
              className:
                'text-medium font-medium border-none !bg-[#d63232] !text-white h-full px-5 py-1 rounded-md',
            }}
            cancelButtonProps={{
              className:
                'text-medium font-medium border-none !bg-gray-400 px-5 py-1 rounded-md !text-white h-full',
            }}
            title={
              <span className="font-medium text-medium pb-5">
                {' '}
                Are you sure to delete this view?
              </span>
            }
            bordered={false}
            icon={<AlertIcon className={'mr-3'} />}
            onConfirm={() => handleDelete(record)}
            okText="Yes"
            cancelText="No"
            overlayClassName="manage_popup "
          >
            <BinIcon />
          </Popconfirm>
        </div>
      ),
    },
  ];

  const columnsMobile = [
    {
      title: <div className=""></div>,
      dataIndex: 'title',
      key: 'title',
      width: 150,
      render: (text, record) => (
        <div className="">
          {isEditing === record.id ? (
            <div className="">
              {showError &&
                isEditing === record.id &&
                !editedTitle.length > 0 && (
                  <div className="text-red-500 text-xs mt-1">
                    Title cannot be empty.
                  </div>
                )}
              <div className="flex gap-2 items-center">
                <div className="flex items-center border border-[#e5e8eb] rounded-lg">
                  <Input
                    id="rename"
                    bordered={false}
                    value={editedTitle}
                    onChange={handleRenameEdit}
                    className="bg-white shadow-md"
                  />
                </div>
                <div
                  id="updateIcon"
                  className="bg-[#00d091] rounded-full flex items-center justify-center p-1"
                >
                  <UpdateIcon
                    onClick={() =>
                      editedTitle.trim() !== ''
                        ? handleTickClick(record)
                        : setShowError(true)
                    }
                  />
                </div>
                <div
                  id="closeIcon"
                  className="ml-2 bg-[#d63232] rounded-full flex items-center justify-center p-1"
                >
                  <CloseAiIcon
                    stroke="#ffffff"
                    fill="#ffffff"
                    onClick={handleXClick}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="">
              <div className="flex gap-2 items-center ">
                <div className="text-md font-semibold">Title:</div>
                <div className="flex items-center">
                  <div>{text}</div>
                </div>

                <div className="ml-2">
                  <EditableIcon onClick={() => handleEditClick(record)} />
                </div>
              </div>
            </div>
          )}
          <div className="mt-2 flex gap-2">
            <div className="text-md font-semibold">Filters: </div>
            <div className="flex flex-wrap text-wrap">
              {record?.practitioners?.map((practitioner, innerIndex) => (
                <span key={innerIndex} className="whitespace-normal">
                  {practitioner.practitionerId === 'All'
                    ? 'All'
                    : practitioner.practitionerName}
                  {innerIndex < record.practitioners.length - 1 && ', '}
                </span>
              ))}
              {record?.date && <div>/ {record?.date}</div>}
              {record?.status ? <div>/ {record.status}</div> : <div>/ All</div>}
            </div>
          </div>
        </div>
      ),
    },
    // {
    //     title: 'Filters',
    //     dataIndex: 'variables',
    //     key: 'variables',
    // },
    {
      title: 'Default View',
      dataIndex: '',
      key: 'actions',
      render: (text, record) => {
        return (
          <div className="flex space-x-6 ml-8">
            <Radio
              checked={record?.isDefaultView}
              onChange={() => handleRadioChange(record)}
            />
          </div>
        );
      },
    },
    {
      title: <div className=""></div>,
      key: 'actions',
      render: (text, record) => (
        <div className="flex space-x-3 manage_popup">
          <Popconfirm
            okButtonProps={{
              className:
                'text-medium font-medium border-none !bg-[#d63232] !text-white h-full px-5 py-1 rounded-md',
            }}
            cancelButtonProps={{
              className:
                'text-medium font-medium border-none !bg-gray-400 px-5 py-1 rounded-md !text-white h-full',
            }}
            title={
              <span className="font-medium text-medium pb-5">
                {' '}
                Are you sure to delete this view?
              </span>
            }
            bordered={false}
            icon={<AlertIcon className={'mr-3'} />}
            onConfirm={() => handleDelete(record)}
            okText="Yes"
            cancelText="No"
            overlayClassName="manage_popup "
          >
            <BinIcon />
          </Popconfirm>
        </div>
      ),
    },
  ];

  const data = Array.isArray(recentSearchList?.search_preference)
    ? recentSearchList.search_preference.map((search) => ({
        key: search.title,
        ...search,
        variables: (
          <div className="flex flex-wrap text-wrap">
            {search?.practitioners?.map((practitioner, innerIndex) => (
              <span key={innerIndex} className="whitespace-normal">
                {practitioner.practitionerId === 'All'
                  ? 'All'
                  : practitioner.practitionerName}
                {innerIndex < (search.practitioners?.length || 0) - 1 && ', '}
              </span>
            ))}
            {search?.date && <div>/ {search?.date}</div>}
            {search?.status ? <div>/ {search.status}</div> : <div>/ All</div>}
          </div>
        ),
      }))
    : [];
  return (
    <>
      <ModalComponent
        centered={true}
        open={isMangeViewOpen}
        handleCancel={handleCloseManageView}
        submitButtonText=""
        cancelButtonText="Cancel"
        closable={true}
        className={'notificationHistory-page-table'}
        additionalBody={
          <>
            <div className="mb-5 font-medium text-xl">Manage views</div>
            <div className="ant-table rounded-xl shadow-lg">
              <Table
                showHeader={isMobile ? false : true}
                columns={isMobile ? columnsMobile : columnsDesktop}
                className={'notification-table-wrapper'}
                dataSource={data}
                pagination={false}
              />
            </div>
          </>
        }
      />
    </>
  );
};
